// extracted by css-extract-rspack-plugin
export default {"actions-list":"CampaignActionsBottomSheet-module__actions-list--Cjg1r","actionsList":"CampaignActionsBottomSheet-module__actions-list--Cjg1r"};